import React, { forwardRef } from 'react';

/**
 * Text input wrapping `.input-field`.
 */
const Input = forwardRef(function Input({ className = '', ...rest }, ref) {
  return <input ref={ref} className={`input-field ${className}`.trim()} {...rest} />;
});

export default Input;
